import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';
import { MobileNumberValidator } from '../../validators/mobile-number.validator';
import { UserProfileService } from './user-profile.service';
import { EmsServiceService } from '../EMS/service/ems-service.service';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent implements OnInit {
  content: any;

  //Specific to Profile Component
  profileAttachTitle = '';
  isProfileComponent = true;
  profileAcceptedType = ['png', 'jpeg', 'jpg', 'bmp', 'tiff'];
  profileMaxSize = 2;
  profileUniqueAttachID = 'User Profile';
  isAllowFileToAttachProfile = true;
  profileAttachID = '';
  if_change = false;
  attachemnt: any;
  userName = 'NA';
  userId = 'NA';
  removeAttachId: any;
  removeProfilePic: boolean = false;
  uniqueTelNo = true;
  uniqueMobile = true;
  uniqueEmail = true;
  constructor(
    private httpClient: HttpClient,
    private dialogRef: MatDialogRef<UserProfileComponent>,
    public userProfileService: UserProfileService,
    public emsService: EmsServiceService,
    private authenticationService: AuthenticationService
  ) {}

  expForm: FormGroup;
  selectedGen;
  maxDate = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth(),
    new Date().getDate()
  );
  isUpdated = false;
  initialFormData = null;

  ngOnInit(): void {
    this.expForm = new FormGroup({
      firstname: new FormControl(null, []),
      middlename: new FormControl(null, []),
      lastname: new FormControl(null, []),
      email: new FormControl(null, []),
      phone: new FormControl(null, [
        Validators.pattern(
          this.userProfileService?.emsConfig?.mobileNoPattern
            ? this.userProfileService?.emsConfig?.mobileNoPattern
            : '^[0,6-9]{1}[0-9]{9,10}'
        ),
      ]),
      gender: new FormControl('', [Validators.required]),
      dob: new FormControl(null),
      attachemnt: new FormControl(null),
    });
    this.expForm?.controls['firstname'].addValidators([
      Validators.required,
      Validators.maxLength(40),
      Validators.pattern(
        this.userProfileService?.emsConfig?.firstNamePattern
          ? this.userProfileService?.emsConfig?.firstNamePattern
          : "^[a-zA-Z-' ]+(\\\\s{0,1})*([a-zA-Z.-])*([a-zA-Z])+$"
      ),
    ]);
    this.expForm?.controls['middlename'].addValidators([
      Validators.maxLength(40),
      Validators.pattern(
        this.userProfileService?.emsConfig?.middleNamePattern
          ? this.userProfileService?.emsConfig?.middleNamePattern
          : "^[a-zA-Z-' ]+(\\\\s{0,1})*([a-zA-Z.-])*([a-zA-Z])+$"
      ),
    ]);
    this.expForm?.controls['lastname'].addValidators([
      Validators.required,
      Validators.maxLength(40),
      Validators.pattern(
        this.userProfileService?.emsConfig?.lastNamePattern
          ? this.userProfileService?.emsConfig?.lastNamePattern
          : "^[a-zA-Z-' ]+(\\\\s{0,1})*([a-zA-Z.-])*([a-zA-Z])+$"
      ),
    ]);
    this.expForm?.controls['email'].addValidators([
      Validators.required,
      Validators.maxLength(35),
      Validators.pattern(
        this.userProfileService?.emsConfig?.emailidPattern
          ? this.userProfileService?.emsConfig?.emailidPattern
          : ".+@.+.[a-zA-Z'-]+"
      ),
    ]);
   
    this.expForm?.controls["firstname"].disable();
    this.expForm?.controls["middlename"].disable();
    this.expForm?.controls["lastname"].disable();
    this.expForm?.controls["email"].disable();
    this.expForm?.controls["phone"].disable();

    this.populateData();
    if (this.userProfileService?.emsConfig?.isMobileNumberMandatory) {
      this.expForm.controls['phone']?.addValidators(Validators.required);
    }
  }

  reset(): void {
    this.expForm.reset();
    this.populateData();
  }

  onFinalPathForProfile(finalPath): void {
    //Will provide the finalPath for first component
    this.attachemnt = finalPath;
    this.expForm.controls['attachemnt'].setValue(finalPath ? finalPath : null);
  }
  update(): void {
    let empPhotoAttachId;
    if (this.removeProfilePic) {
      empPhotoAttachId = null;
    } else {
      empPhotoAttachId = this.profileAttachID;
    }
    const dataforpost = {
      empServiceFlag: 1,
      empId: this.content.empId,
      //empNo: this.content.empId,
      empNo: this.content.empNo,
      empMiddleName: this.expForm.controls['middlename'].value,
      empFirstName: this.expForm.controls['firstname'].value,
      empLastName: this.expForm.controls['lastname'].value,
      empDOB: moment(this.content?.empDOB).format('DD-MMM-YYYY'),
      genderId: this.expForm.controls['gender'].value,
      userName: this.content.userName,
      asAPIFlag: true,
      enableThumbAuthentication: false,
      mobile_no: this.expForm.controls['phone'].value,
      isWebAPI: false,
      appTypeID: this.content.appTypeID,
      emailID: this.expForm.controls['email'].value,
      empPhotoAttachId: empPhotoAttachId,
      attachmentReference: this.attachemnt,
    };

    this.httpClient.put('/admin/user-profiles', dataforpost).subscribe(() => {
      this.dialogRef.close(true);
      this.isUpdated = true;
    });
  }
  onUniqueEmail(event: string): void {
    this.expForm.controls['email'].markAsTouched();
    this.uniqueEmail = true;
    if (
      this.expForm.controls['email'].valid &&
      this.expForm.controls['email'].value !== this.content.emailID
    ) {
      this.emsService
        .checkUniqueEmail(event, { id: this.content.empId })
        .subscribe((res: any) => {
          if (!res?.data?.isValid) {
            this.uniqueEmail = false;
          } else {
            this.uniqueEmail = true;
          }
        });
    } else {
      this.uniqueEmail = true;
    }
  }

  onUniqueMobile(event: string): void {
    this.expForm.controls['phone'].markAsTouched();
    this.uniqueMobile = true;
    if (this.expForm.controls['phone'].valid) {
      if (
        event.length >=
        Number(this.userProfileService?.emsConfig?.mobileNoDigits) - 1
      ) {
        this.emsService
          .checkUniqueMobile(event, { id: this.content.empId })
          .subscribe((res: any) => {
            if (!res?.data?.isValid) {
              this.uniqueMobile = false;
            } else {
              this.uniqueMobile = true;
            }
          });
      }
    } else {
      this.uniqueMobile = true;
    }
  }

  populateData(): void {
    this.authenticationService.getUserDetails().subscribe((res) => {
      this.content = res;
      this.userName =
        this.content?.empFirstName + ' ' + this.content?.empLastName;
      this.userId = this.content?.userName;
      //start set value in form from json
      this.expForm.controls['firstname'].setValue(this.content.empFirstName);
      this.expForm.controls['middlename'].setValue(this.content.empMiddleName);
      this.expForm.controls['lastname'].setValue(this.content.empLastName);
      this.expForm.controls['email'].setValue(this.content.emailID);
      this.expForm.controls['phone'].setValue(this.content.mobile_no);
      this.expForm.controls['gender'].setValue(this.content.genderId);
      this.expForm.controls['dob'].setValue(this.content?.empDOB);
      if (this.content.empPhotoAttachId) {
        this.profileAttachID = this.content.empPhotoAttachId;
        // /this.expForm.controls['attachemnt'].setValue(this.profileAttachID);
      }
      this.initialFormData = JSON.parse(JSON.stringify(this.expForm.value));
    });
  }

  onChanges(): void {
    this.expForm.valueChanges.subscribe(() => {
      this.if_change = true;
    });
  }
  removeImage(removeAttachmentment, attachId) {
    if (removeAttachmentment) {
      this.removeProfilePic = true;
    }
  }
  checkUpdate(): boolean {
    let valid = false;
    if (
      JSON.stringify(this.initialFormData) ===
      JSON.stringify(this.expForm.value)
    ) {
      valid = true;
    }
    if (this.profileAttachID && this.removeProfilePic) {
      valid = false;
    }
    return valid;
  }
}
